export interface CatalogLadle {
  LadleId: number | null;
  LadleName: string;
  Enabled: boolean;
  IsActive: boolean;
}
export const CATALOG_LADLE_INITIAL_VALUES: CatalogLadle = {
  LadleId: null,
  LadleName: "",
  Enabled: true,
  IsActive: true,
};
